import {useState, useEffect} from 'react'
import data from '../data'
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { AiOutlineArrowRight , } from "react-icons/ai";
function Projects() {
  const [index, setindex] = useState(0);
  function leftShiftHandler() {
    if (index ===  0){
      setindex(data.length - 1);
    } else {
      setindex(index - 1);
    }
    ;
  }
  function rightShiftHandler() {
    if (index === data.length - 1) {
      setindex(0);
    } else {
      setindex(index + 1);
    }
    
  }
  function dotHandler1() {
    setindex(0);
  }
  function dotHandler2() {
    setindex(1);
  }
  function dotHandler3() {
    setindex(2);
  }
  useEffect(() => {
    if (index ===0) {
      document.getElementById("dot0").classList.add("currentdot");
      document.getElementById("dot1").classList.remove("currentdot");
      document.getElementById("dot2").classList.remove("currentdot");
      
    } else if (index === 1) {
      document.getElementById("dot1").classList.add("currentdot");
      document.getElementById("dot2").classList.remove("currentdot");
      document.getElementById("dot0").classList.remove("currentdot");
      
    } else {
      document.getElementById("dot2").classList.add("currentdot");
      document.getElementById("dot1").classList.remove("currentdot");
      document.getElementById("dot0").classList.remove("currentdot");
     
    }
  }, [index]);

  return (
    <div id="Projects" className="pt-[55px]">
      <div className="flex flex-col  items-center  justify-center mx-auto  font-Poppins ">
        <h1 className=" font-Poppinsb font-bold text-[3rem]">Projects</h1>
        <div className="opacity-75 text-center max-w-[20rem] md:max-w-[28rem]">
          Designs that tranforms, responsive that performs...
        </div>
      </div>
      <div className="flex flex-row md:justify-evenly justify-center  ">
        <div className="pt-[12rem]  cursor-pointer " onClick={leftShiftHandler}>
          <FiChevronLeft size={45} className="text-deep" />
        </div>
        <div className="flex flex-col md:flex-row pt-[5rem]  md:space-x-20 sm:space-y-12 b-3 border-b-deep  ">
          <div className=' lg:mt-10'>
            <img
              src={data[index].image}
              className=" max-w-[303px] h-[190px] rounded-lg"
              alt="problem"
            ></img>
          </div>
          <div className=" flex  flex-col space-y-2 ">
            <p className=" text-[26px] font-bold font-Poppinsb">
              {data[index].title}
            </p>
            {/* <p className="max-w-[20rem]">{data[index].text}</p> */}
            <p className="max-w-[20rem] opacity-70">{data[index].skills}</p>
            <a href={data[index].link} target="_blank" rel="noreferrer">
              <div className="relative  ">
                <button className="red-btn rounded-lg pl-6  py-3 px-12  ">
                  Check Out
                </button>
                <span className="absolute z-[50] left-[110px] top-[17px] ">
                  <AiOutlineArrowRight className="text-black1" size={20} />
                </span>
              </div>
            </a>
          </div>
        </div>
        <div className="pt-[12rem] cursor-pointer" onClick={rightShiftHandler}>
          <FiChevronRight size={45} className="text-deep" />
        </div>
      </div>
      <div className="  flex space-x-3 justify-center   mt-10">
        <div id="dot0">
          <div
            className="w-2 h-2 rounded-full bg-[#000000] opacity-20 cursor-pointer"
            onClick={dotHandler1}
          ></div>
        </div>
        <div id="dot1">
          <div
            className="w-2 h-2 rounded-full bg-[#000000] opacity-20 cursor-pointer"
            onClick={dotHandler2}
          ></div>
        </div>
        <div id="dot2">
          <div
            className="w-2 h-2 rounded-full bg-[#000000] opacity-20 cursor-pointer"
            onClick={dotHandler3}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default Projects
